import type { RouteObject } from 'react-router-dom'
import { ApplyPage, CardPage } from './CardPages'
import { StaffCardPage, StaffCardQueue } from './StaffCardPages'
import { StaffCardFunnel } from './StaffCardFunnel'
import { PartnersPage } from './PartnersPage'

// CHANGE-card: the ernd card application. ernd.io's buttons send people to /card/apply (through /login?next=
// when signed out); a signed-in person with no company starts here too, and the first screen makes the company.
export const routes: RouteObject[] = [
  { path: '/card', element: <CardPage /> },
  { path: '/card/apply', element: <ApplyPage /> },
  { path: '/partners', element: <PartnersPage /> },   // CHANGE-073; the partner sign-in short link while card-only is off
  { path: '/staff/card', element: <StaffCardQueue /> },
  { path: '/staff/card/funnel', element: <StaffCardFunnel /> },
  { path: '/staff/card/:id', element: <StaffCardPage /> },
]
